import { z } from 'zod';
import { LOCALE_MODES, SUPPORTED_LOCALES } from './locales.js';
export const localeSchema = z.enum(SUPPORTED_LOCALES);
export const localeModeSchema = z.enum(LOCALE_MODES);
//# sourceMappingURL=locale-schemas.js.map